var _effectorFileName = "/builds/gmini/front-utils/src/race.ts";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import { awaitFirst } from './awaitFirst';
export var race = function race() {
  for (var _len = arguments.length, pubs = new Array(_len), _key = 0; _key < _len; _key++) {
    pubs[_key] = arguments[_key];
  }

  return Promise.race(pubs.map(function (pub) {
    return 'watch' in pub ? awaitFirst(pub) : pub;
  }));
};